import { createFileRoute } from "@tanstack/react-router";
import { PracticeMasterPage, practiceMasterHead } from "@/components/site/PracticeMasterPage";
import { practiceMasterPages } from "@/data/practice-master-pages";

const page = practiceMasterPages[7];
export const Route = createFileRoute("/practice-areas/medical-malpractice-lawyer-seo")({
  head: () => practiceMasterHead(page),
  component: () => <PracticeMasterPage page={page} />,
});
